import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { getAllUsers, getFriends, sendFriendRequest, getPendingRequests, acceptFriendRequest, rejectFriendRequest, removeFriend, cancelFriendRequest } from '../../services/databaseService';
import './Friends.css';
import { useNavigate, Link } from 'react-router-dom';
import { Spinner } from '../../components/Spinner/Spinner';
import LoginPrompt from '../../components/LoginPrompt/LoginPrompt';
import { onSnapshot, query, where, or, collection, doc, getDocs } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { pageStateStore } from '../../services/pageStateStore';
import { useLocation } from 'react-router-dom';
import UserAvatar from '../../components/UserAvatar/UserAvatar';
import { auth } from '../../config/firebase';

function Friends() {
  const { user } = useAuth();
  const [allUsers, setAllUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isRestoringState, setIsRestoringState] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const loadFriendsData = async () => {
      if (!user) return;
      
      try {
        setLoading(true);
        await loadUsers();
      } catch (error) {
        console.error('Error loading friends:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    loadFriendsData();
  }, [user]);

  const processUser = (user) => {
    if (!user) {
      console.warn('Received null or undefined user in processUser');
      return null;
    }

    console.log('Processing user:', user);

    const processTimestamp = (timestamp) => {
      if (!timestamp) return null;
      // Handle Firestore Timestamp
      if (typeof timestamp.toDate === 'function') {
        return timestamp.toDate();
      }
      // Handle Date object or string
      const date = new Date(timestamp);
      return isNaN(date.getTime()) ? null : date;
    };

    const processed = {
      ...user,
      createdAt: processTimestamp(user.createdAt),
      lastLogin: processTimestamp(user.lastLogin)
    };

    console.log('Processed user:', processed);
    return processed;
  };

  const loadUsers = async () => {
    if (!user) return;

    try {
      setError(null);
      console.log('🔄 Starting loadUsers for current user:', user.uid);
      
      const users = await getAllUsers();
      console.log('📥 Retrieved users from DB:', users.length);
      
      // Add detailed filtering logs
      console.group('Filtering Steps:');
      const processedUsers = users.map(processUser).filter(Boolean);
      console.log('1. After processing:', processedUsers.length, 'users');
      
      const nonCurrentUsers = processedUsers.filter(u => {
        const filtered = u.uid !== user.uid;
        if (!filtered) console.log('Filtered out current user:', u.displayName);
        return filtered;
      });
      console.log('2. After removing current user:', nonCurrentUsers.length, 'users');
      
      const nonAnonymousUsers = nonCurrentUsers.filter(u => {
        const filtered = !u.isAnonymous;
        if (!filtered) console.log('Filtered out anonymous user:', u.displayName);
        return filtered;
      });
      console.log('3. After removing anonymous users:', nonAnonymousUsers.length, 'users');
      console.groupEnd();
      
      setAllUsers(nonAnonymousUsers);
      console.log('✅ Users state updated successfully');

    } catch (error) {
      console.error('❌ Error loading users:', error);
      setError(error.message);
      throw error;
    }
  };

  const handleSignOut = async () => {
    try {
      sessionStorage.removeItem('googleAuthInProgress'); // Clear auth state
      await auth.signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const handleSecretClick = () => {
    window.location.href = '/film.html';
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="friends-container">
      <div className="current-user-section">
        <h2>Inloggad som</h2>
        <div className="current-user-card">
          <div className="user-info-container">
            <UserAvatar user={user} size="medium" />
            <div className="user-info">
              <div className="user-name">{user?.displayName || 'Anonymous User'}</div>
            </div>
          </div>
          <button 
            className="sign-out-btn"
            onClick={handleSignOut}
          >
            Logga ut
          </button>
        </div>
      </div>

      <h2>Användare</h2>
      <div className="users-grid">
        {allUsers.map(otherUser => (
          <div key={otherUser.uid} className="user-card">
            <Link 
              to={`/friend/${otherUser.uid}`} 
              className="user-card-link"
            >
              <div className="user-info-container">
                <UserAvatar user={otherUser} size="medium" />
                <div className="user-info">
                  <div className="user-name">{otherUser.displayName || 'Anonymous User'}</div>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      {user?.uid === 'hVJPhDmhNme7YycaHNOef0pnDHx1' && (
        <button 
          onClick={handleSecretClick}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'transparent',
            cursor: 'default',
            padding: '20px',
            width: '100%',
            marginTop: '20px'
          }}
        >
          ⠀
        </button>
      )}
    </div>
  );
}

export default Friends;